import FaqComponents from "../components/FaqComponents";

function Faq() {
  return (
    <>
      <FaqComponents />
    </>
  );
}

export default Faq;
